// extracted by mini-css-extract-plugin
export default {"wrapper":"Controller_wrapper__7FAQ-","delete":"Controller_delete__XJeRK","edit":"Controller_edit__sN8l8"};